module.exports = __webpack_public_path__ + "assets/images/vcr_officeBuilding-01.b95e0a1ed7762a59383ba86ff05f6a25.svg";